import { EnumOwnerType, PersonDetailsQuery } from "gql/generated";
import { Link, List } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { ListingCard } from "./ListingCard";
import { EmptyState, ViewSubSection } from "shared/components";
import { Button } from "@ttc3k/trekker";
import { useLoggedInAs } from "shared/hooks";
import { useState } from "react";
import { ConnectToListingModal } from "../../modals/ConnectToListingModal/ConnectToListingModal";

export type ListingsProps = {
  personId: string;
  listings:
    | NonNullable<PersonDetailsQuery["personDetails"]>["operators"]
    | undefined
    | null;
};

export type OperatorType = NonNullable<
  NonNullable<
    NonNullable<PersonDetailsQuery["personDetails"]>["operators"]
  >[number]
>;

export const Listings = ({ personId, listings }: ListingsProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.LISTINGS",
  });
  const loggedInAs = useLoggedInAs();
  const isOrganization = loggedInAs?.type === EnumOwnerType.Organization;

  const [isConnectToListingModalOpen, setIsConnectToListingModalOpen] =
    useState(false);

  return (
    <>
      <Flex direction="column" gap="300">
        <ViewSubSection
          Icon={List}
          title={t("TITLE")}
          description={t("DESCRIPTION")}
          buttonOverride={
            isOrganization && (
              <Button
                visual="unstyled"
                Icon={Link}
                fontSize="16px"
                fontWeight="500"
                color="text.accent.blue.mid"
                _hover={{
                  color: "text.accent.blue.dark",
                }}
                _focusVisible={{
                  color: "text.accent.blue.dark",
                }}
                onClick={() => setIsConnectToListingModalOpen(true)}
              >
                {t("CTA_BUTTON_COPY")}
              </Button>
            )
          }
        />
        {listings && listings.length === 0 && (
          <EmptyState
            ctaButtonProps={
              isOrganization
                ? {
                    onClick: () => setIsConnectToListingModalOpen(true),
                    children: t("CTA_BUTTON_COPY"),
                  }
                : undefined
            }
            text={!isOrganization ? t("NO_LISTINGS_TEXT") : undefined}
          />
        )}
        {listings?.map(
          // Each listing is an operator
          // Each operator can have multiple organizations
          (listing, index) =>
            listing && (
              <ListingCard
                allListings={listings}
                key={listing._entityId + index}
                personId={personId}
                listing={listing}
              />
            ),
        )}
      </Flex>
      <ConnectToListingModal
        isOpen={isConnectToListingModalOpen}
        personId={personId}
        onClose={() => setIsConnectToListingModalOpen(false)}
        onConnectSuccess={() => setIsConnectToListingModalOpen(false)}
      />
    </>
  );
};
